<template>
  <v-card class="card-center pb-2" outlined>
    <v-container class="px-4 py-4" fluid>
      <v-card outlined>
        <v-tabs fixed-tabs v-model="tab">
          <v-tab class="ml-0">{{ $t('ELE0028') }}</v-tab>
          <v-tab>{{ $t('ELE0213') }}</v-tab>
          <v-tab-item class="px-2">
            <v-row dense>
              <v-col cols="4">
                <InspecionCompanyInput v-model="searchCondition.inspCompanyCd" />
              </v-col>
              <v-col cols="3">
                <TextFieldInput v-model="searchCondition.lotNo" :label="$t('ELE0049')" />
              </v-col>
              <v-col cols="2">
                <TextFieldInput v-model="searchCondition.partCd" :label="$t('ELE0031')" />
              </v-col>
              <v-col cols="3">
                <TextFieldInput v-model="searchCondition.partName" :label="$t('ELE0032')" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <TextFieldInput v-model="searchCondition.inspIndexNo" :label="$t('ELE0137')" />
              </v-col>
              <v-col cols="2">
                <TextFieldInputWithDatePicker v-model="searchCondition.inspDateFrom" :label="$t('ELE0138')" />
              </v-col>
              <span class="d-flex flex-row space-between mx-4 mt-3">
                {{ $t('ELE0141') }}
              </span>
              <v-col cols="2">
                <TextFieldInputWithDatePicker v-model="searchCondition.inspDateTo" :label="$t('ELE0138')" />
              </v-col>
              <v-col cols="3">
                <TextFieldInput :label="$t('ELE0224')" v-model="searchCondition.model" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <InspTimingDtlMultipleInput v-model="searchCondition.inspTimingDtlCd" :inspTimingCd="inspTimingCd"/>
              </v-col>
              <v-col cols="2">
                <Checkbox :label="$t('ELE0263')" v-model="searchCondition.isLatestNumOfInsp" />
              </v-col>
              <v-col class="d-flex justify-end">
                <BtnSearch @click="onClickSearch" />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item class="pl-2 pb-4">
            <v-row dense>
              <v-col cols="4">
                <InspQRCodeInput
                  v-model="searchCondition.qrCode"
                  @scanned="searchByQrCode"
                  @error="resetSearchResult"
                />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-card>
      <v-card outlined>
        <v-card-title class="pt-1 pb-0">
          {{ $t('ELE0023') }}
        </v-card-title>
        <v-data-table :headers="headers" :items="items" dense>
          <template v-slot:item.action="{ item }">
            <IconInquiry @click="onClickInquiry(item)" />
          </template>
          <template v-slot:item.inspStatusCd="{ item }">
            {{ getEnumlang('InspIndex.InspStatusCd.', item.inspStatusCd) }}
          </template>
          <template v-slot:item.inspResultCd="{ item }">
            <td class="v-data-table__divider" :style="{ 'background-color': getColorInspResult(item.inspResultCd) }">
              {{ getInspResultName('InspResultCd.', item.inspResultCd, item.isOutCl) }}
            </td>
          </template>
          <template v-slot:item.inspClassCd="{ item }">
            {{ getEnumlang('InspClassCd.', item.inspClassCd) }}
          </template>
          <template v-slot:item.numOfInsp="{ item }">
            <span v-if="item.numOfInsp == item.maxNumOfInsp">({{ $t('ELE0262') }})</span>
            {{ item.numOfInsp }}
          </template>
          <template v-slot:item.inspIndexNo="{ item }">
            <BtnLink :label="item.inspIndexNo" @click="onClickInspIndexNo(item)" />
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-if="appInspDialog" v-model="appInspDialog" scrollable persistent>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0158') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="appInspDialog = false" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text class="px-0">
          <InputAppInspForm
            :inspIndexNo="selectedItem.inspIndexNo"
            :cav.sync="selectedItem.cav"
            :numOfInsp.sync="selectedItem.numOfInsp"
            @reset="research"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dimInspDialog" v-model="dimInspDialog" scrollable persistent>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0159') }}
          <v-spacer />
          <Btn
            icon="mdi-close"
            @click="
              dimInspDialog = false
              onClickSearch()
            "
            depressed
            iconProp
            color="white"
          />
        </v-card-title>
        <v-card-text class="px-0">
          <InputDimInspForm
            :inspIndexNo="selectedItem.inspIndexNo"
            :cav.sync="selectedItem.cav"
            :numOfInsp.sync="selectedItem.numOfInsp"
            @reset="research"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <ApprovalInspDataListDialog
      v-if="selectedInspIndexItem && inspDtlRefDialog"
      :dialog.sync="inspDtlRefDialog"
      isInquiry
      inspDataViewOnly
      :inspIndexNo="selectedInspIndexItem.inspIndexNo"
      :inspCompanyCd="selectedInspIndexItem.inspCompanyCd"
      :lotNo="selectedInspIndexItem.lotNo"
      :partCd="selectedInspIndexItem.partCd"
      :partName="selectedInspIndexItem.partName"
      :lotDate="selectedInspIndexItem.lotDate"
      :inspCat1="selectedInspIndexItem.inspCat1"
      :inspCat2="selectedInspIndexItem.inspCat2"
    />
  </v-card>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'
import { InspClassCd } from '@/enum'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import { InspResultCd, CompanyCatCd } from '@/enum'

import Btn from '@/components/atoms/base/button/Btn'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnLink from '@/components/atoms/base/button/BtnLink'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import InspQRCodeInput from '@/components/atoms/text-field/InspQRCodeInput'

import InspecionCompanyInput from '@/components/atoms/select/InspecionCompanyInput'
import InputAppInspForm from '@/components/organisms/terminal/form/InputAppInspForm'
import InputDimInspForm from '@/components/organisms/terminal/form/InputDimInspForm'
import InspTimingDtlMultipleInput from '@/components/atoms/select/InspTimingDtlMultipleInput'
import ApprovalInspDataListDialog from '@/components/organisms/terminal/dialog/ApprovalInspDataListDialog.vue'

export default {
  name: 'SearchInspResultForm',

  mixins: [APIUtils, Message, Loading, DateUtils, StringUtils],

  components: {
    ValidationObserver,
    Btn,
    BtnSearch,
    BtnLink,
    TextFieldInput,
    TextFieldInputWithDatePicker,
    IconInquiry,
    Checkbox,
    InspecionCompanyInput,
    InspQRCodeInput,
    InputAppInspForm,
    InputDimInspForm,
    InspTimingDtlMultipleInput,
    ApprovalInspDataListDialog,
  },

  data() {
    return {
      tab: '',
      headers: [
        { text: this.$t('ELE0307'), value: 'action', width: '90', divider: true, sortable: false },
        { text: this.$t('ELE0139'), value: 'inspStatusCd', divider: true },
        { text: this.$t('ELE0181'), value: 'inspResultCd', divider: true },
        { text: this.$t('ELE0048'), value: 'inspCompanyName', divider: true },
        { text: this.$t('ELE0049'), value: 'lotNo', divider: true },
        { text: this.$t('ELE0031'), value: 'partCd', divider: true },
        { text: this.$t('ELE0032'), value: 'partName', divider: true },
        { text: this.$t('ELE0224'), value: 'model', divider: true },
        { text: this.$t('ELE0437'), value: 'inspTimingDtlName', divider: true },
        { text: this.$t('ELE0157'), value: 'cav', divider: true },
        { text: this.$t('ELE0156'), value: 'inspClassCd', divider: true },
        { text: this.$t('ELE0098'), value: 'numOfInsp', divider: true, align: 'end' },
        { text: this.$t('ELE0138'), value: 'inspDate', divider: true },
        { text: this.$t('ELE0137'), value: 'inspIndexNo' },
      ],
      searchCondition: {
        qrCode: '',
        inspCompanyCd: '',
        lotNo: '',
        partCd: '',
        partName: '',
        model: '',
        inspIndexNo: '',
        inspDateFrom: moment().format('YYYY-MM-DD'),
        inspDateTo: moment().format('YYYY-MM-DD'),
        isLatestNumOfInsp: true,
        inspTimingDtlCd: [],
      },
      items: [],
      appInspDialog: false,
      dimInspDialog: false,
      selectedItem: null,
      scannedInspIndexNo: '',
      inspDtlRefDialog: false,
      selectedInspIndexItem: null,
      inspTimingCd: this.$store.getters.canOQCOnly ? this.$store.getters.getIQCorOQC : ''
    }
  },

  computed: {
    companyCatCd: {
      get() {
        if (this.$store.getters.companyCatCd == CompanyCatCd.SUPPLIER) {
          return this.$store.getters.companyCatCd
        }
        return ''
      },
    },
  },

  methods: {
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },

    getColorInspResult(inspResultCd) {
      // 検査結果に対応する色設定
      let color = ''

      if (inspResultCd == InspResultCd.OK) {
        color = '#EDEFFD'
      } else if (inspResultCd == InspResultCd.SA_OK) {
        color = '#FCF4A1'
      } else if (inspResultCd == InspResultCd.NG) {
        color = '#F8CED2'
      }

      return color
    },

    async searchByQrCode(inspIndexNo) {
      try {
        this.startLoading()
        this.scannedInspIndexNo = inspIndexNo

        const params = {
          userCompanyCd: this.$store.getters.companyCd,
          inspIndexNo: inspIndexNo,
        }
        this.items = await API.get('/inspIndex/inspResult', params)
      } catch (error) {
        this.resetSearchResult()
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0206') })))
      } finally {
        this.stopLoading()
      }
    },

    async onClickSearch() {
      try {
        this.startLoading()
        this.scannedInspIndexNo = ''

        const params = {
          userCompanyCd: this.$store.getters.companyCd,
          inspCompanyCd: this.searchCondition.inspCompanyCd,
          lotNo: this.searchCondition.lotNo,
          partCd: this.searchCondition.partCd,
          partName: this.searchCondition.partName,
          model: this.searchCondition.model,
          inspIndexNo: this.searchCondition.inspIndexNo,
          inspDateFrom: this.searchCondition.inspDateFrom,
          inspDateTo: this.searchCondition.inspDateTo,
          isLatestNumOfInsp: this.searchCondition.isLatestNumOfInsp,
          inspTimingDtlCd: this.searchCondition.inspTimingDtlCd,
        }
        this.items = await API.get('/inspIndex/inspResult', params)
      } catch (error) {
        this.resetSearchResult()
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0206') })))
      } finally {
        this.stopLoading()
      }
    },

    onClickInquiry(item) {
      this.selectedItem = cloneDeep(item)

      if (item.inspClassCd == InspClassCd.APP) {
        this.appInspDialog = true
      } else if (item.inspClassCd == InspClassCd.DIM) {
        this.dimInspDialog = true
      }
    },

    onClickInspIndexNo(item) {
      // this.$router.push({ name: 'T03', query: { inspIndexNo: inspIndexNo } }).catch(() => {})
      this.selectedInspIndexItem = {
        ...cloneDeep(item),
        lotDate: this.toLocalDate(item.inspCreateDatetime),
      }
      this.inspDtlRefDialog = true
    },

    research() {
      this.appInspDialog = false
      this.dimInspDialog = false

      if (this.scannedInspIndexNo) {
        this.searchByQrCode(this.scannedInspIndexNo)
      } else {
        this.onClickSearch()
      }
    },

    resetSearchResult() {
      this.items = []
    },
  },
}
</script>
